import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { RoleAssignment } from './role-assignment';
export { RoleAssignment };
import { roleAssignmentSchema } from '@schemas/business-objects/role-assignment';
import { RoleFormGroup } from './role-form-group';
import { UserFormGroup } from './user-form-group';

export class RoleAssignmentFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    userId: SchemaFormControl;
    user: UserFormGroup;
    roleId: SchemaFormControl;
    role: RoleFormGroup;
  };

  declare value: Partial<RoleAssignment>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(roleAssignmentSchema, RoleAssignment, data, options);
  }

  get object(): RoleAssignment {
    return new RoleAssignment(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'user':
        return new UserFormGroup();
      case 'role':
        return new RoleFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<RoleAssignment[]> {
    return RoleAssignment.find(filter);
  }

  static async findOne(filter?: any): Promise<RoleAssignment | null> {
    return RoleAssignment.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<RoleAssignment> {
    return RoleAssignment.findById(id, filter);
  }

  static async create(data: Partial<RoleAssignment>): Promise<RoleAssignment> {
    return RoleAssignment.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<RoleAssignment>,
  ): Promise<RoleAssignment> {
    return RoleAssignment.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return RoleAssignment.deleteById(id);
  }
}

export class RoleAssignmentFormArray extends PersistedFormArray {
  declare controls: RoleAssignmentFormGroup[];

  readonly entityName = 'RoleAssignment' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(roleAssignmentSchema, RoleAssignment, options);
  }

  protected override createItemGroup() {
    return new RoleAssignmentFormGroup();
  }

  get array(): RoleAssignment[] {
    return this.controls.map((group: RoleAssignmentFormGroup) => group.object);
  }
}

export class RoleAssignmentPersistedArray extends PersistedArray<RoleAssignment> {
  readonly entityName = 'RoleAssignment' as const;

  constructor(options?: PersistedArrayOptions) {
    super(RoleAssignment, options);
  }
}
